import { Component, Input, Output } from '@angular/core';
import {
  SaleElectronicPrescriptionAnswer,
  } from '../../models/sale-electronic-prescription-answer';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import {  ViewChild, ElementRef, SimpleChanges, EventEmitter } from '@angular/core';
import { PCTableInputModel, PCTableOutputModel } from '../../models/pc-table-input-model';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms'; 
import { CheckBook } from '../../models/check-book';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-credit-multi-payment',
  templateUrl: './credit-multi-payment.component.html',
  styleUrls: ['./credit-multi-payment.component.css']
})
export class CreditMultiPaymentComponent {
  public constructor(
    private logger: LoggerService,
    private apiService: UserApiService,
  ){
    this.getCheckBooks();
    this.getCompany();
  }
 
  public modalSuccessConfirm: boolean = false;
  public paymentAmount: number = 0;
  public companyList: any[] = [];
  public factorList: any[] = [];
  public selectedFactor: any[] = [];
  public companyId: string='';
  public loading: boolean = false;
  public showPayment: boolean = false;
  public prescriptions?: SaleElectronicPrescriptionAnswer;
  public backendJson: any = {};
  public checkBooks: CheckBook[] = [];
  public monthName: string = '';

  public sellerList: any[] = [];

  @ViewChild('datePicker') popoverDataPicker!: NgbPopover;

  @Input() thisItem: any;
  @Output() parentActionOutput = new EventEmitter<PCTableOutputModel>();


  public getCompany() {
    try {
      this.loading = true;
      let url = `DrugDistributor?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.companyList = [];
          }
          if (result.succeeded) {
            this.companyList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.title,
              persianName: current.title,
              companyTypeId: current.companyTypeId,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public changeCompany(event) {
    if (event.id) {
      this.backendJson.drugDistributorId = event.id;
      this.getFactor();
    }
  }
  
  // public getSeller(drugDistributorId: string) {
  //   try {
  //     this.loading = true;
  //     let url = `Seller/SpecificCompany/${drugDistributorId}`;
  //     if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
  //       return;
  //     }

  //     this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
  //       (result) => {
  //         this.logger.addResponseLog(url, result, `Get All`);
  //         if (!result.data) {
  //           this.sellerList = [];
  //         }
  //         if (result.succeeded) {
  //           if (result.data) {
  //             this.sellerList = result.data.map((current) => ({
  //               id: current.id,
  //               name:
  //                 current.mobileNumber == null
  //                   ? current.firstName + ' ' + current.lastName
  //                   : current.firstName +
  //                   ' ' +
  //                   current.lastName +
  //                   ' - ' +
  //                   current.mobileNumber,
  //               persianName:
  //                 current.mobileNumber == null
  //                   ? current.firstName + ' ' + current.lastName
  //                   : current.firstName +
  //                   ' ' +
  //                   current.lastName +
  //                   ' - ' +
  //                   current.mobileNumber,
  //             }));
  //           } else {
  //             this.sellerList = [];
  //           }
  //         } else {
  //           this.logger.addBackEndMessage(result);
  //         }
  //         this.loading = false;
  //       },
  //       (error) => {
  //         this.apiService.AddErrorLog(error);
  //         this.loading = false;
  //       },
  //       () => {
  //         this.loading = false;
  //       }
  //     );
  //   } catch (e) {
  //     this.logger.addException(e, true);
  //     this.loading = false;
  //   }
  // }
  
  public getFactor(){
    try {
      this.loading = true;
      let url = `BuyFactor/Distributor/${this.backendJson.drugDistributorId}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.factorList = [];
          }
          if (result.succeeded) {
            this.factorList = result.data!.map((current) => ({
              id: current.id,
              totalPrice: current.totalPrice,
              factorDate: current.factorDate,
              factorId: current.factorId,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public checkAndPay(){
    //TODO: validation 
    this.showPayment=true;
  }

  public callParent(method:string){
    this.parentActionOutput.emit(new PCTableOutputModel(method, undefined));

  }

  public selectFactor(item:any,index:number){
    if (item.selected) {
      item.selected=false;
      this.selectedFactor.slice(index,1);
      this.paymentAmount-=item.totalPrice;
    }else{
      item.selected=true;
      this.selectedFactor.push(item);
      this.paymentAmount+=item.totalPrice;
    }
  }
  
  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {

      case 'Successed':
        this.modalSuccessConfirm = true;
        break;

    }
  }

  public getCheckBooks() {
    try {
      this.loading = true;

      let url = `CheckBook?pageNumber=1&pageSize=10&paging=true&orderBy=&direction=asc`

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url))
        .subscribe(
          result => {
            this.logger.addResponseLog(url, result, `Get All`);
            if (!result.data) {
              this.checkBooks = [];
            } else {
              this.checkBooks = result.data.items
                .map(current => ({
                  id: current.id,
                  recivedDate: current.recivedDate,
                  bankAccountId: current.bankAccountId,
                  bankAccountName: current.bankAccountName,
                  name: current.name,
                  persianName: current.name,
                  checks: [],
                  loading: false,
                }));

              setTimeout(() => {
                let selectStockPage = document.getElementById("selectStockPage");
                if (selectStockPage) {
                  selectStockPage.classList.remove("animate__backInDown");
                }
              }, 2 * 1000);
            }
            this.loading = false;
          },
          error => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public selectCheck(check: any) {
    for (let index = 0; index < this.checkBooks.length; index++) {
      const element = this.checkBooks[index];
      for (let secondIndex = 0; secondIndex < element.checks.length; secondIndex++) {
        const secondelement = element.checks[secondIndex];
        secondelement.isSelect = false;
      }
    }
    if (!check.isSelect) {
      this.backendJson.checkNumber = check.checkNumber
      this.backendJson.checkId = check.id
      check.isSelect = true;
    } else {
      this.backendJson.checkNumber = null
      check.isSelect = false;
    }
  }

  public getCheck(checkBook: any) {
    try {
      checkBook.isOpen = true;
      checkBook.loading = true;

      let url = `Check/ListView/${checkBook.id}`

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url))
        .subscribe(
          result => {
            this.logger.addResponseLog(url, result, `Get All`);

            if (result.succeeded) {
              if (result.data == null) {
                return
              }
              checkBook.checks = result.data
                .map(current => ({
                  id: current.id,
                  cost: current.cost,
                  checkNumber: current.checkNumber,
                  accountNumber: current.accountNumber,
                  isPassed: current.isPassed,
                  paymentId: current.paymentId,
                  isSelect: false,
                }));
            }

            checkBook.loading = false;
          },
          error => {
            this.apiService.AddErrorLog(error);
            checkBook.loading = false;
          },
          () => {
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      checkBook.loading = false;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

}
